import { generateResourceSelectors } from '../generators/resource.selectors';
import * as types from './project-task.types';

export const projectTaskSelectors = {
  ...generateResourceSelectors<types.IProjectTask>((state) => state.resource.projectTask),
};
